import moment from "moment";

export const getTimeTillNow = (date) => {
  const initialDate = moment(date, "YYYY-MM-DD HH:mm:ss");
  const currentDate = moment();
  const duration = moment.duration(currentDate.diff(initialDate));

  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();
  const formattedSeconfs = seconds.toString().padStart(2, "0");

  return `${hours}:${minutes}:${formattedSeconfs}`;
};
